import { ErrorFieldEntity } from '../../../shared/http.types';

export type MappedErrors = {
  handledErrors: ErrorFieldEntity[],
  unhandledErrors: ErrorFieldEntity[]
}

export enum Step2Field {
  NAME = 'name',
  DOMAIN = 'domain',
  CURRENCY = 'currency'
}
